import React from 'react'
import { connect } from 'react-redux'
import { Button } from 'antd-mobile'
import { Container, Footer, Wrapper, BlankWrapper, Header } from '../../components_renew/Layout'
import { AddressItem } from '../../components_renew/Address/AddressItem'
import { componentUpdateWithToast } from '../../components_renew/HOC'
import { defaultForm } from '../../reducers/addressReducer'
import { handleCatch } from '../../utils'
import {
  requestAddressData,
  setAddressForm,
  setAddressSelected
} from '../../actions/addressAction'

let { ADDRESS } = window.PATH

@connect(state => {
  return state.addressData
})
@componentUpdateWithToast
class AddressList extends React.PureComponent {
  componentDidMount () {
    let { invalid, list } = this.props
    if (!(list.length > 0) || invalid) {
      this.props.dispatch(requestAddressData())
    }
  }

  render () {
    let {
      list
    } = this.props
    return <Container>
      <Header>收货地址</Header>
      {
        (list.length > 0)
          ? <Wrapper>
            <div>
              {
                list.map((item) => {
                  return <AddressItem onSelect={this.onAddressSelect.bind(this, item)} key={item.id} {...item}
                    onEdit={this.onEdit.bind(this, item)}
                    onDelete={this.onDelete.bind(this, item)}
                  />
                })
              }
            </div>
          </Wrapper>
          : <BlankWrapper icon={'icon-list'}>暂无收货地址</BlankWrapper>
      }
      <Footer>
        <Button style={{ margin: 'auto' }} size={'small'} color={'primary'}
          onClick={this.toNewAddress}>新增收货地址</Button>
      </Footer>
    </Container>
  }

  onAddressSelect = (item) => {
    this.props.dispatch(setAddressSelected(item))
    this.props.history.goBack()
  }

  onEdit = item => {
    this.props.dispatch(setAddressForm({ ...item }))
    this.props.history.push(ADDRESS.FORM)
  }

  onDelete = ({ id }) => {
    let config = {
      method: 'delete',
      url: window.API.Address.deleteAddress(id)
    }
    window.toast.show('数据提交中')
    window.axios.request(config).then(() => {
      this.props.dispatch(requestAddressData())
    }).catch(handleCatch)
  }

  toNewAddress = () => {
    this.props.dispatch(setAddressForm({ ...defaultForm }))
    this.props.history.push(ADDRESS.ADD)
  }

}

export { AddressList }
